module cr.events {
    class ResultGroupController {

        gridData:any;
        runnerDetails:any;
        bibNumber:Number;
        activeItemIndex:Number;
        groupId:Number;

        static $inject = ['eventView','timingConfiguration', 'TrackingService', '$scope', '$stateParams', '$modal','Overview','$state'];

        SelectResult(result)
        {
            console.log("Select Result"+angular.toJson(result));
            switch (result.ReportType.toLowerCase()){
                case "link":
                    break;

                case "time":
                    this.$state.go("event.reports.group.report",{reportId: result.Id});
                    break;

                case "xml":
                    window.location.href="https://prod.chronorace.be/Classements/classement.aspx?eventId="+this.$stateParams["eventId"]+"&mode=large&idClassement="+result.Id;
                    break;

                case "file":
                    /*switch (result.Settings.FileType.toLowerCase()){
                     }*/
                    window.location.href="https://crdev.blob.core.windows.net/files/"+result.Settings.FileName;
                    break;


                default:
                    return "fa fa-chevron-right";

            }
        }

        GetIcon(result)
        {
            switch (result.ReportType){
                case "Link":
                    return "fa fa-external-link";

                case "File":
                    switch (result.Settings.FileType.toLowerCase()){
                        case "pdf":
                            return "fa fa-file-pdf-o";

                        case "xls":
                            return "fa fa-file-excel-o";

                        default:
                            return "fa fa-file-o";
                    }
                    break;

                default:
                    return "fa fa-chevron-right";

            }
        }


        constructor(private eventView, private timingConfiguration,  private trackingService, private $scope, private $stateParams, private $modal,private Overview,private $state) {

            $scope.groupId=this.$stateParams['groupId'];
            $scope.Mask=0;

            $scope.Overview=Overview;

            $scope.groupData=_.find(timingConfiguration.ResultGroups,g=>(<any>g).GroupId==$scope.groupId);

            $scope.StateName=$state.current.name;

            $scope.resultName=this.$stateParams['splitName'];

            console.log("splitName in ctrl:"+this.$stateParams['splitName']);

            switch ($state.current.name) {
                case "event.results.group":
                    if (Overview[$scope.groupId] && Overview[$scope.groupId].SplitCfg){

                        $state.go(".split.detail",{splitName:Overview[$scope.groupId].SplitCfg});
                    } else {
                        console.log("Current location?? "+Overview[$scope.groupId].SplitCfg);
                        $state.go(".home");
                    }
                    break;
            }

            // redirect?



            $scope.IsFlagSelected=flag=>{
                //console.log("flag: "+flag+" - "+($scope.Mask&flag==flag));
                return ($scope.Mask&flag)==flag;
            }

            $scope.FormatPosition=(pos,status)=>{

                switch (status)
                {
                    case 1:
                        return "DSQ";

                    case 2:
                        return "DNF";

                    case 3:
                        return "DNS";

                    default:
                        return pos+".";

                }

            }

            $scope.pageSize=25;
            $scope.curPage=0;
            $scope.Toggle=flag=>{
                $scope.Mask=$scope.Mask^flag;
            }
            $scope.SetResultPage=(page)=>{
                console.log("set page "+page);

                trackingService.getResult($scope.groupId,$scope.resultName,$scope.eventView.EventId,0,(page-1)*$scope.pageSize,$scope.pageSize).then(data=>{
                    //console.log("erg: "+angular.toJson(data));
                    $scope.results=data;
                });
            }


            $scope.eventView=eventView;
            $scope.SelectRow=(row)=>{
              console.log("select row");
            };
            $scope.timingConfiguration=timingConfiguration;

           // console.log("kiki??... "+angular.toJson($scope.eventView));

            $scope.results={ ResultView:[],Stats:{} };

            $scope.$watch(()=>$scope.Mask+"_"+$scope.resultName, _.debounce(function (id) {
                // This code will be invoked after 1 second from the last time 'id' has changed.
                $scope.$apply(function(){


                    trackingService.getResult($scope.groupId,$scope.resultName,$scope.eventView.EventId,0,$scope.curPage*$scope.pageSize,$scope.pageSize).then(data=>{
                        //console.log("erg: "+angular.toJson(data));
                        $scope.results=data;
                    });

                })


            }, 500));

        }



    }

    eventModule
        .controller('resultGroupController', ResultGroupController);


}
